/**
 * Convert a file to base64 string (Promise-based)
 * @param file - The file blob to convert
 * @returns Promise resolving to base64 string
 */
export const fileToBase64 = (file: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      resolve(reader.result as string);
    });
    reader.addEventListener('error', (error) => {
      reject(error);
    });
    reader.readAsDataURL(file);
  });
};

/**
 * Convert a file to base64 string (Callback-based)
 * For compatibility with existing code patterns
 * @param file - The file blob to convert
 * @param callback - Callback function receiving the base64 URL
 */
export const getBase64 = (file: Blob, callback: (url: string) => void): void => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(file);
};
